import * as React from 'react'
import cx from 'classnames'
import { observer } from 'mobx-react'
import { ApprovedTransactionViewModel } from 'payouts/admin/review/ApprovedTransactionViewModel'
import styles from './ApprovedTransaction.sass'
import { IconButton } from 'components/IconButton'
import Icon from 'components/Icon'
import { formatTransactionReason } from 'payouts/formatters/transaction-formatters'
import {
  DropdownItem,
  DropdownItemTitle,
  Dropdown,
  DropdownTitle,
} from 'components/Dropdown'
import { Amount } from 'payouts/components/Amount'
import { TransactionSourceType } from 'payouts/TransactionSourceType'
import { match } from 'utils/pattern-match-util'

interface ApprovedTransactionProps {
  disabled: boolean
  vm: ApprovedTransactionViewModel
}

/**
 * The ApprovedTransaction
 */
export default observer(function ApprovedTransaction({
  disabled,
  vm,
}: ApprovedTransactionProps) {
  return (
    <div className={cx(styles.root)}>
      <div className={styles.content}>
        <div className={styles.info}>
          <div className={styles.title}>
            <div className={styles.recipient}>
              {vm.transaction.recipient.displayName}
            </div>

            <div className={cx(styles.amount)}>
              <Amount value={vm.transaction.amount} />
            </div>
          </div>
          <div className={styles.subtitle}>
            {match(vm.transaction.source, {
              [TransactionSourceType.User]: () => (
                <>{formatTransactionReason(vm.transaction.reason)}</>
              ),
              [TransactionSourceType.Job]: () => (
                <>
                  Job payout
                  <div className={styles.identifier}>
                    {vm.transaction.jobId}
                  </div>
                </>
              ),
              [TransactionSourceType.Unknown]: () => <>Unknown Source Type</>,
            })}
          </div>
        </div>
        <div className={styles.actions}>
          <Dropdown
            autoDismiss
            disabled={disabled}
            button={
              <IconButton loading={vm.tasks.pending} disabled={disabled}>
                <Icon name="more" />
              </IconButton>
            }
          >
            <DropdownTitle>Actions</DropdownTitle>
            <DropdownItem icon={<Icon name="close" />} onClick={vm.remove}>
              <DropdownItemTitle>Remove</DropdownItemTitle>
            </DropdownItem>
          </Dropdown>
        </div>
      </div>
    </div>
  )
})
